import * as React from 'react';

import { Button } from '@mui/material';
import { VerticalButtonPanel } from '../subs/ButtonPanel';
import { PageSection } from '../subs/PageSection';
import { WorkshopInfoPanel } from '../subs/WorkshopInfoPanel';
import { Page } from '../subs/Page';
import { ButtonLink } from '../subs/ButtonLink';

import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ThreePIcon from '@mui/icons-material/ThreeP';
import PeopleIcon from '@mui/icons-material/People';
import PrintIcon from '@mui/icons-material/Print';
import { useLocation } from 'react-router-dom';
import { WorkshopSettings } from '../modals/WorkshopSettingsModal';

export const WSAdminstration = () => {
    const pageLocation = useLocation();
    const {id, guid, workshop, location: wsLocation, contactEmail, startDate, endDate, status, paymentType, informationUrl, fee, maxUsers} = pageLocation.state;

    const workshopSettings: 
        WorkshopSettings = { name: workshop, guid: guid, contactEmail, startDate: startDate, endDate: endDate, location: wsLocation, status: status, paymentType: paymentType, informationUrl, fee: fee, maxUsers: maxUsers};

    return <Page heading={workshop??"undefined"} backButton breadcrumbs>
        <PageSection>
            {[<WorkshopInfoPanel location={wsLocation} startDate={startDate} endDate={endDate} guid={guid} logInfo={informationUrl} supportMail={contactEmail}></WorkshopInfoPanel>]}
        </PageSection>

        <PageSection columnSpacing={30}>
            <VerticalButtonPanel heading={"This workshop specific"}>
                <ButtonLink to={`/WSTestingStart/${id}/true`} startIcon={<AssessmentIcon />} fullWidth>{"Monitor status"}</ButtonLink>
                <ButtonLink to={`/WorkshopSettingsModal/${id}`} startIcon={<SettingsIcon/>} 
                            state={{background: pageLocation, workshopSettings}} fullWidth>
                    {"Modify Settings"}
                </ButtonLink>
                <ButtonLink to={`/WorkshopStatisticsModal/${id}`} startIcon={<AssessmentIcon />}
                    state={{ background: pageLocation, workshopSettings }} fullWidth>
                    {"View Statistics"}
                </ButtonLink>
            </VerticalButtonPanel>
            <VerticalButtonPanel heading={"This workshop Users"}>
                <ButtonLink to={`/WSUserAdministration/${id}`} startIcon={<FormatListBulletedIcon/>} fullWidth>{"List all users"}</ButtonLink>
                <ButtonLink to="/TransferRegistrationModal" startIcon={<PeopleIcon/>} state={{background: pageLocation, workshopId: id}} fullWidth>{"Transfer one to another"}</ButtonLink>
                <ButtonLink to="/EmulateUserModal" startIcon={<ThreePIcon/>} state={{background: pageLocation}} fullWidth>{"Emulate user"}</ButtonLink>
            </VerticalButtonPanel>
            <VerticalButtonPanel heading={"Participants of this Workshop"}>
                {[<Button startIcon={<PrintIcon/>} fullWidth>{"Print list of all participants"}</Button>]}
            </VerticalButtonPanel>
        </PageSection>
    </Page>
}